import React, { useState } from "react";
import { Badge, Button, Form, ListGroup, Spinner } from "react-bootstrap";
import { useStudentSearch } from "../hooks/useStudentSearch";

/**
 * Live autocomplete over registered students. As the user types a name,
 * document or id, matching students of the academy appear with their current
 * hours balance. Calls onSelect(student|null).
 */
function StudentSearchPicker({ selected, onSelect, label = "Buscar estudiante" }) {
  const [query, setQuery] = useState("");
  const { data: results = [], isFetching } = useStudentSearch(query);

  if (selected) {
    return (
      <div className="d-flex justify-content-between align-items-center border rounded p-2">
        <div>
          <div className="fw-semibold">{selected.name}</div>
          <div className="text-muted small">
            {selected.document ? `Doc. ${selected.document} · ` : ""}
            {selected.hours_balance} h disponibles
          </div>
        </div>
        <Button
          variant="link"
          className="p-0 text-muted"
          onClick={() => onSelect(null)}
        >
          Cambiar
        </Button>
      </div>
    );
  }

  return (
    <>
      <Form.Group controlId="student-search">
        <Form.Label>{label}</Form.Label>
        <Form.Control
          type="text"
          placeholder="Nombre, documento o ID…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          autoComplete="off"
          autoFocus
          style={{ minHeight: 44 }}
        />
      </Form.Group>

      {query.trim().length >= 1 && (
        <ListGroup className="mt-2" style={{ maxHeight: 240, overflowY: "auto" }}>
          {isFetching && results.length === 0 && (
            <ListGroup.Item className="text-muted small text-center">
              <Spinner size="sm" animation="border" className="me-2" />
              Buscando…
            </ListGroup.Item>
          )}
          {!isFetching && results.length === 0 && (
            <ListGroup.Item className="text-muted small text-center">
              Sin resultados para “{query.trim()}”.
            </ListGroup.Item>
          )}
          {results.map((s) => (
            <ListGroup.Item
              key={s.id}
              action
              onClick={() => onSelect(s)}
              className="d-flex justify-content-between align-items-center"
            >
              <div>
                <div className="fw-medium">{s.name}</div>
                {s.document && (
                  <div className="text-muted small">Doc. {s.document}</div>
                )}
              </div>
              <Badge bg={s.hours_balance > 0 ? "success" : "secondary"} pill>
                {s.hours_balance} h
              </Badge>
            </ListGroup.Item>
          ))}
        </ListGroup>
      )}
    </>
  );
}

export { StudentSearchPicker };
